var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0833333333333333,0,0,1.0833333333333333,0,0)"
  }, /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}"), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.8 3.8h16.4m-16.4 0h16.5v19.5H3.8zm16.4 19.4H3.8M20.2 3.8H3.8l1.4-3h13.6zM.8 23.2h22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2 21c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2v2.2h4.5V21zM7.5 6.4c.2 0 .4.2.4.4m-.8 0c0-.2.2-.4.4-.4m0 .7c-.2 0-.4-.1-.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9 6.8c0 .2-.2.4-.4.4m0 3.7c.2 0 .4.2.4.4m-.8-.1c0-.2.2-.4.4-.4m0 .8c-.2 0-.4-.2-.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9 11.2c0 .2-.2.4-.4.4m0 3.8c.2 0 .4.2.4.4m-.8 0c0-.2.2-.4.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5 16.1c-.2 0-.4-.2-.4-.4h0m.8.1c0 .2-.2.4-.4.4h0M12 6.4c.2 0 .4.2.4.4m-.8 0c0-.2.2-.4.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12 7.1c-.2 0-.4-.2-.4-.4m.8.1c0 .2-.2.4-.4.4m0 3.7c.2 0 .4.2.4.4m-.8-.1c0-.2.2-.4.4-.4m0 .8c-.2 0-.4-.2-.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4 11.2c0 .2-.2.4-.4.4m0 3.8c.2 0 .4.2.4.4m-.8 0c0-.2.2-.4.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12 16.1c-.2 0-.4-.2-.4-.4h0m.8.1c0 .2-.2.4-.4.4h0m4.5-9.8c.2 0 .4.2.4.4m-.8 0c0-.2.2-.4.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5 7.1c-.2 0-.4-.2-.4-.4m.8.1c0 .2-.2.4-.4.4m0 3.7c.2 0 .4.2.4.4m-.8-.1c0-.2.2-.4.4-.4m0 .8c-.2 0-.4-.2-.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9 11.2c0 .2-.2.4-.4.4m0 3.8c.2 0 .4.2.4.4m-.8 0c0-.2.2-.4.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5 16.1c-.2 0-.4-.2-.4-.4h0m.8.1c0 .2-.2.4-.4.4h0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/buildingIcon.e9fba407bb01f49b344a166cb9b9bb0e.svg";
export { ForwardRef as ReactComponent };